import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import './style/imgModal.less';

interface ImgModalProps {
  visible: boolean;
  src: string;
  close: () => void;
}

const ImgModal = observer((props: ImgModalProps) => {
  const { visible, src, close } = props;

  return (
    <div className={['securityStaff-img-modal', visible ? '' : 'close'].join(' ')} onClick={close}>
      <CloseOutlined onClick={() => close()} />
      <img src={src} alt="" />
    </div>
  )
})

export default ImgModal;
